import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

export function IncidentOmpFormulaNote() {
  const { t } = useTranslation('incidents');

  return (
    <aside
      className="inline-info-note inline-info-note--spaced"
      aria-label={t('omp.formula.title', 'Financial impact formula')}
    >
      <InfoCircleOutlined className="inline-info-note__icon" aria-hidden />
      <div className="inline-info-note__body">
        <p className="inline-info-note__lead">
          <span className="inline-info-note__label">
            {t('omp.formula.title', 'Financial impact formula')}
          </span>
          <span className="inline-info-note__sep" aria-hidden>
            ·
          </span>
          <span>{t('omp.formula.line1')}</span>
        </p>
        <p className="inline-info-note__meta">
          <span>{t('omp.formula.line2')}</span>
          <span className="inline-info-note__sep" aria-hidden>
            ·
          </span>
          <span>{t('omp.formula.line3')}</span>
        </p>
      </div>
    </aside>
  );
}
